{
  "navigation": {
    "dashboard": "Tableau de bord",
    "clients": "Clients",
    "facilities": "Installations",
    "equipment": "Équipements",
    "users": "Utilisateurs",
    "apiData": "Données API",
    "fuseAdmin": "FuSE Admin",
    "reports": "Rapports",
    "unresolvedLogs": "Logs non résolus",
    "viewAllChangeLogs": "Voir tous les journaux de changement",
    "noUnresolvedChangeLogs": "Aucun journal de changement non résolu trouvé.",
    "settings": "Paramètres",
    "company": "Compagnie",
    "statements": "Relevés",
    "support": "Afficher la page d'assistance",
    "adminSearch": "Trouvez rapidement des clients, des installations, des équipements ou des utilisateurs",
    "signedInAs": "Connecté en tant que",
    "editProfile": "Modifier le profil",
    "logout": "Se déconnecter"
  }
}
